const updates = [
  { id: 1, date: '07-30', title: '《星际迷航：新纪元》4K 超清版上线', tag: '新片入库', tagCls: 'bg-accent-100 text-accent-700' },
  { id: 2, date: '07-29', title: '暑期档专题"动作巨制集结"已更新 12 部影片', tag: '专题更新', tagCls: 'bg-primary-100 text-primary-700' },
  { id: 3, date: '07-28', title: '播放线路全面升级，新增 CDN 加速节点', tag: '系统优化', tagCls: 'bg-secondary-100 text-secondary-700' },
  { id: 4, date: '07-27', title: '《暗影追踪》高清中文字幕版正式上线', tag: '新片入库', tagCls: 'bg-accent-100 text-accent-700' },
  { id: 5, date: '07-26', title: '悬疑烧脑季专题片单扩充至 30 部精选影片', tag: '专题更新', tagCls: 'bg-primary-100 text-primary-700' },
  { id: 6, date: '07-25', title: '移动端播放器适配优化，支持手势控制', tag: '功能更新', tagCls: 'bg-secondary-100 text-secondary-700' },
  { id: 7, date: '07-24', title: '《夏夜之梦》原声大碟同步上线', tag: '周边上线', tagCls: 'bg-primary-100 text-primary-700' },
  { id: 8, date: '07-23', title: '纪录片频道新增 BBC 自然系列 15 部高清影片', tag: '频道更新', tagCls: 'bg-accent-100 text-accent-700' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-sm text-foreground-400 max-w-[500px] mx-auto">
            天堂影院的影片更新、功能升级与运营动态，不错过每一次精彩
          </p>
        </div>

        <div className="max-w-[900px] mx-auto">
          <div className="relative pl-8 md:pl-10 border-l-2 border-background-200/60">
            {updates.map((item, idx) => (
              <div
                key={item.id}
                className={`relative pb-8 md:pb-10 ${idx === updates.length - 1 ? 'pb-0' : ''}`}
              >
                <span className="absolute -left-[25px] md:-left-[29px] top-0 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-50"></span>

                <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                  <span className="text-xs font-medium text-foreground-300 whitespace-nowrap shrink-0">
                    {item.date}
                  </span>
                  <span className={`px-2 py-0.5 rounded-md text-xs font-medium shrink-0 ${item.tagCls}`}>
                    {item.tag}
                  </span>
                </div>

                <h3 className="mt-2 text-sm md:text-base font-medium text-foreground-700 leading-relaxed">
                  {item.title}
                </h3>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}